import React, { useContext } from 'react'
import { useQuery } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import { fetchPolicy } from 'lib/apolloFetchPolicy'
import moment from 'moment'

import EventFormNumberFieldModule from 'components/Events/EventForm/EventFormModules/EventFormNumberFieldModule/EventFormNumberFieldModule'
import { ExtendedFormikContext } from 'components/Forms/ExtendedFormik'
import { EventFormLogicContext } from 'components/Events/EventForm/EventFormLogic'
import ErrorComponent from 'components/Errors/ErrorComponent'

import getMileageModuleData from 'graphql/event/getMileageModuleData.gql'

const EventFormMileageModule = () => {
    const { t } = useTranslation(['events'])
    const { vehicleId, initEvent } = useContext(EventFormLogicContext)
    const { values } = useContext(ExtendedFormikContext)

    const { loading, error, data } = useQuery(getMileageModuleData, {
        variables: {
            vehicleId: vehicleId,
            time: moment(initEvent.eventTime || Date.now()).utc().format('YYYY-MM-DD HH:mm')
        },
        fetchPolicy: fetchPolicy.NETWORK_ONLY,
    })

    const previousEventMileage = data?.previousEventMileage

    const getTipText = () => {
        if (!values.mileage || loading) return null
        if (previousEventMileage) return `${t('events:forms.mileage.prevMileageTip')}  ${moment(previousEventMileage.date).format('DD.MM.YYYY')}: ${previousEventMileage.mileage} km`
    }

    return (
        <>
            {error && <ErrorComponent error={error} noRender />}
            <EventFormNumberFieldModule
                className="event-form-mileage-module"
                name="mileage"
                label={t('events:forms.mileage.label')}
                placeholder={previousEventMileage && previousEventMileage.mileage}
                unitsTip="km"
                tipText={getTipText()}
                icon={['far', 'tachometer-fast']}
            />
        </>
    )
}

export default EventFormMileageModule
